// frontend/src/components/auth/RequireAuth.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireAuth = ({ children, adminOnly, officeOnly }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show nothing while checking authentication status
  if (loading) {
    return null;
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    // Save the attempted URL for redirecting after successful login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && currentUser.role !== 'admin' && currentUser.role !== 'dev') {
    // Admin only route, but user is not an admin or dev
    return <Navigate to="/dashboard" replace />;
  }

  if (officeOnly && !['admin', 'dev', 'office'].includes(currentUser.role)) {
    // Office only route, but user is not office staff, admin, or dev
    return <Navigate to="/dashboard" replace />;
  }

  // User is authenticated, render the protected route
  return children;
};

export default RequireAuth;